<yc-modal
  [modalHeader]="'common:hdrInAppAlertHeaderForGrantsConnect' | ycI18n: 'GrantsConnect Alert'"
  [primaryButtonText]="'common:textClose' | ycI18n: 'Close'"
  (onPrimaryClick)="closeModal.emit(doNotShowAgain)">

  <div class="mb-3">
    <span [innerHTML]="inAppAlert.body | escapeHtml"></span>
  </div>

  <div>
    <yc-checkbox  
      name="doNotShowAgain"
      [(value)]="doNotShowAgain"
      [optionLabel]="'common:textDoNotShowThisAnnouncementAgain' | ycI18n: 'Do not show announcement again'">
    </yc-checkbox>
  </div>


</yc-modal>